



































































import {Component, Prop, Vue} from "vue-property-decorator";
import {Request} from "@/modules/request/Request";
import {Getter} from "vuex-class";
import Configuration from "front-component/Configuration";
import _ from "lodash";
import {BudgetAllocation} from "@/modules/budget/BudgetAllocation";
import {requestStatus} from "@/Constants";

@Component({})
export default class RequestFormButtons extends Vue {
    @Prop({required: true}) private isDocument!: boolean;
    @Prop({required: true}) private canEditRequest!: (request: Request) => boolean;
    @Prop({required: true}) private loading!: boolean;
    @Prop({required: true}) private isDocumentsListDisplayed!: boolean;
    @Prop({required: true}) private countDocument!: number;
    @Prop({required: true}) private canCreateMlCampaign!: (request: Request) => boolean;
    @Prop({required: true}) private isEditingOrNew!: boolean;
    @Prop({required: true}) private selectedRequest!: Request;
    @Prop({required: true}) private classByStatus!: string;
    @Prop({required: true}) private disabledMoveRequest!: boolean;
    @Prop({required: true}) private requestMain!: string;

    @Getter("getUserDepartment") public userDepartment!: string;
    @Getter("getBudgetAllocations") public budgetAllocations!: BudgetAllocation[];

    private showDocumentList() {
        this.$emit("show-document-list");
    }
    private showCommentList() {
        this.$emit("show-comment-list");
    }

    private get requestStatus() {
        return requestStatus;
    }

    private createMlCampaign(request: Request): void {
        window.open(Configuration.get("mlSpiritUri") + request.uuid);
    }

    private copyClipboard(request: Request): void {
        const el = document.createElement("textarea");
        el.value = this.requestContent(request);
        document.body.appendChild(el);
        el.select();
        try {
            document.execCommand("copy");
            this.$message({
                message: _.invoke(this.$options.filters, "trans", "contentCopiedInClipboard"),
                type: "success"
            });
        } catch (err) {
            this.$message({
                message: _.invoke(this.$options.filters, "trans", "errorCopyingInClipboard"),
                type: "error"
            });
        }
        document.body.removeChild(el);
    }

    private openLogs() {
        this.$emit("open-logs");
    }

    private openMoveRequest() {
        this.$emit("open-move-request");
    }

    private requestContent(request: Request): string {
        let budgetString = "";
        _.forEach(request.allocations, (allocation) => {
            if (allocation.amount > 0) {
                const budgetAllocation = _.find(this.budgetAllocations, (bAlloc: BudgetAllocation) => {
                    return bAlloc.uuid === _.get(allocation, "budgetAllocation.uuid", "");
                });
                budgetString += _.invoke(this.$options.filters, "trans", _.get(budgetAllocation, "label", "")) + " - " +
                    _.invoke(this.$options.filters, "price", allocation.amount) + "\r";
            }
        });

        return _.invoke(this.$options.filters, "trans", "requestNumber") + " : " + request.code + "\r" +
            _.invoke(this.$options.filters, "trans", "campaign") + " : " + request.title + "\r" +
            _.invoke(this.$options.filters, "trans", "description") + " : " + request.description + "\r" +
            _.invoke(this.$options.filters, "trans", "campaignDates") + " : " +
            _.invoke(this.$options.filters, "date", request.beginDate) + " - " +
            _.invoke(this.$options.filters, "date", request.endDate) + "\r" +
            _.invoke(this.$options.filters, "trans", "budget") + " :\r" +
            budgetString
            ;
    }
}
